// removed by extract-text-webpack-plugin
module.exports = {"sideBySideLayout":"SideBySideLayout-hashed__sideBySideLayout__3sVQZ","left":"SideBySideLayout-hashed__left__3hhVd","right":"SideBySideLayout-hashed__right__AnbnJ"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/side-by-side-layout/SideBySideLayout-hashed.scss
// module id = 1213
// module chunks = 0